import { useSessionQuery } from '../session/useSessionQuery.ts';
import type { UseAclInfo } from './context/PermissionHookTypes.ts';

export const useAclInfo: UseAclInfo = () => {
  const { data, isPending } = useSessionQuery();

  return {
    info: data?.acl,
    isLoading: isPending,
  };
};
